import ModalGuidelines from 'components/ProductPage/QuestionsAndAnswers/ModalGuidelines/ModalGuidelines';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedModalGuidelines = withGlobalModals(ModalGuidelines);

export default ConnectedModalGuidelines;
